import React from 'react';

// Centralized translation strings for Google Translate
export const TRANSLATION_KEYS = {
    'stopping-answer': 'Stopping answer generation...',
    'feedback-title1': 'Appreciate Your Feedback',
    'feedback-title2': 'Share Your Feedback',
    'chat-history': 'Chat History',
    'conversation-id': 'Conversation ID:',
    'caution-label': 'Cautions on relying on artificial intelligence (AI):',
    'stopped-answer': 'Answer generation stopped.',
    'role': 'User:',
    'related-questions': 'Related Questions:',
    'ai-content': 'AI-generated content',
    'page': 'Page',
    'of': 'of',
    'generating-answer': 'Generating answer...',
    'error-case-exists': 'That case already exists!',
    'error-case-not-found': 'Case not found. Please check the case number and try again.',
    'error-no-cases': 'There are no cases associated with this account. Please try again.',
    'error-incorrect-info': 'The information entered is incorrect. Please try again.',
    'error-validation-failed': 'An error occurred while validating your credentials. Please try again.',
    'error-ssn-format': 'SSN must be exactly 9 digits.',
    'error-dob-format': 'DOB must be in YYYY-MM-DD format.',
    'error-field-required': 'Required:',
    'error-unsupported-character': 'Unsupported character ignored.',
    'error-no-matches': 'No matches found.',
    'edit': 'Edit',
    'done': 'Done'
};

// Utility function to get translated text from the translate-strings container
export const getTranslatedText = (key: string): string => {
    const element = document.querySelector(`#translate-strings [data-key="${key}"]`);
    const text = element?.textContent || '';

    // Clean up Google Translate artifacts (leading/trailing periods and extra spaces)
    return text.trim().replace(/^\.\s*/, '').replace(/\s*\.$/, '');
};

// Props for TranslationStrings component
interface TranslationStringsProps {
    cautionLine1?: string;
    cautionLine2?: string;
}

// Component to render hidden translation strings for Google Translate
export const TranslationStrings: React.FC<TranslationStringsProps> = ({
    cautionLine1,
    cautionLine2
}) => (
    <div id="translate-strings" style={{ position: 'absolute', left: '-9999px', top: '0', visibility: 'hidden' }} aria-hidden="true">
        <span data-key="generating-answer">{TRANSLATION_KEYS['generating-answer']}</span>
        <span data-key="stopping-answer">{TRANSLATION_KEYS['stopping-answer']}</span>
        <span data-key="feedback-title1">{TRANSLATION_KEYS['feedback-title1']}</span>
        <span data-key="feedback-title2">{TRANSLATION_KEYS['feedback-title2']}</span>
        <span data-key="chat-history">{TRANSLATION_KEYS['chat-history']}</span>
        <span data-key="conversation-id">{TRANSLATION_KEYS['conversation-id']}</span>
        <span data-key="caution-label">{TRANSLATION_KEYS['caution-label']}</span>
        <span data-key="cautionLine1">{cautionLine1}</span>
        <span data-key="cautionLine2">{cautionLine2}</span>
        <span data-key="stopped-answer">{TRANSLATION_KEYS['stopped-answer']}</span>
        <span data-key="role">{TRANSLATION_KEYS['role']}</span>
        <span data-key="related-questions">{TRANSLATION_KEYS['related-questions']}</span>
        <span data-key="ai-content">{TRANSLATION_KEYS['ai-content']}</span>
        <span data-key="page">{TRANSLATION_KEYS['page']}</span>
        <span data-key="of">{TRANSLATION_KEYS['of']}</span>
        {/* Error messages (rendered in SlidingPane portal, won't auto-translate) */}
        <span data-key="error-case-exists">{TRANSLATION_KEYS['error-case-exists']}</span>
        <span data-key="error-case-not-found">{TRANSLATION_KEYS['error-case-not-found']}</span>
        <span data-key="error-no-cases">{TRANSLATION_KEYS['error-no-cases']}</span>
        <span data-key="error-incorrect-info">{TRANSLATION_KEYS['error-incorrect-info']}</span>
        <span data-key="error-validation-failed">{TRANSLATION_KEYS['error-validation-failed']}</span>
        <span data-key="error-ssn-format">{TRANSLATION_KEYS['error-ssn-format']}</span>
        <span data-key="error-dob-format">{TRANSLATION_KEYS['error-dob-format']}</span>
        <span data-key="error-field-required">{TRANSLATION_KEYS['error-field-required']}</span>
        <span data-key="error-unsupported-character">{TRANSLATION_KEYS['error-unsupported-character']}</span>
        <span data-key="error-no-matches">{TRANSLATION_KEYS['error-no-matches']}</span>
        {/* Profile panel edit toggle (mobile pane renders in a SlidingPane portal, won't auto-translate) */}
        <span data-key="edit">{TRANSLATION_KEYS['edit']}</span>
        <span data-key="done">{TRANSLATION_KEYS['done']}</span>
    </div>
);
